import { useDispatch } from 'react-redux'
import type { AppDispatch } from '../AppState/AppStore'

export const useAppDispatch = () => useDispatch<AppDispatch>()
